"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = Image;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function Image(_ref) {
  var src = _ref.src,
      raised = _ref.raised,
      rounded = _ref.rounded,
      className = _ref.className,
      rest = _objectWithoutProperties(_ref, ["src", "raised", "rounded", "className"]);

  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("img", _extends({}, rest, {
    src: src,
    className: "".concat(rounded ? 'rounded-full' : 'rounded-xl', " ").concat(raised ? 'shadow-lg' : '', " max-w-full h-auto align-middle border-none ").concat(className)
  })));
}

Image.defaultProps = {
  raised: false,
  rounded: false
};
Image.propTypes = {
  src: _propTypes["default"].string.isRequired,
  raised: _propTypes["default"].bool.isRequired,
  rounded: _propTypes["default"].bool.isRequired
};